import React, { useState } from 'react';
import NBJobsTable from './NBJobs/NBJobsTable';
import EPRTable from './EPR/EPRTable';
import TargetsTable from './EPR/TargetsTable';
import PPRTable from './PPR/PPRTable';

import './Dashboard.scss';

const Dashboard = () => {
  const [EPRTargetsLoading, SetEPRTargetsLoading] = useState(false);
  const [detailsRow, setDetailsRow] = useState(null);

  return (
    <div className="dashboard-container">
      <div className="pane-container flex1">
        <div className="pane-header">YOUR NB JOBS</div>
        <div className="pane-content">
          <NBJobsTable />
        </div>
      </div>
      <div className="epr-view flex2">
        <div className="pane-container flex1">
          <div className="pane-header">EPR</div>
          <div className="pane-content">
            <EPRTable
              SetEPRTargetsLoading={SetEPRTargetsLoading}
              setSelectedRow={setDetailsRow}
            />
          </div>
        </div>
        <div className="pane-container flex1">
          <div className="pane-header">EPR - TARGETS</div>
          <div className="pane-content">
            <TargetsTable loading={EPRTargetsLoading} detailsRow={detailsRow} />
          </div>
        </div>
      </div>
      <div className="pane-container flex2">
        <div className="pane-header">PPR</div>
        <div className="pane-content">
          <PPRTable />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
